import companyLogo from 'assets/funnel/powerserv_logo_2.png';
import aiDisclaimer from 'assets/funnel/ai-disclaimer.png';
import handshakeImg from 'assets/funnel/hand_shake_lkw.png';

import heroImg from 'assets/funnel/lackier_start.png';
import infoHeroImg from 'assets/funnel/lackier_main.png';
import jobDetailsImg from 'assets/funnel/lackier_job_details.png';
import groupImg from 'assets/funnel/lackier_group.png';

const lackierer = {
  documentTitle: "Lackierer:in (m/w/d) | POWERSERV Austria GmbH",
  companyLogo,
  companyName: "POWERSERV Austria GmbH",
  aiDisclaimer,

  landing: {
    heroImg,
    chipText: "Farbe bekennen.",
    heroTitle: "Lackierer:in (m/w/d) · Vollzeit",
    heroSubtitle: "Wir suchen dich! Verstärke das Team unseres Kunden in der Schienenfahrzeugtechnik.",
    facts: [
      { icon: 'bi-clock',          title: '38,5 Std. / Woche',       subtitle: '2-Schichtbetrieb 06:00 – 22:00 Uhr' },
      { icon: 'bi-cash-stack',     title: '€ 3.058,– + Überstunden', subtitle: 'voll ausbezahlt – kein Zeitausgleich' },
      { icon: 'bi-calendar-check', title: 'Start: ehestmöglich',     subtitle: 'langfristiger Einsatz' },
      { icon: 'bi-geo-alt-fill',   title: '1110 Wien',               subtitle: 'Öffentlich erreichbar' },
    ],
  },

  info: {
    heroImg: infoHeroImg,
    heroChip: "Vollzeit · Schienenfahrzeugtechnik",
    heroTitleLines: ["Lackierer:in", "(m/w/d)"],
    facts: [
      { value: "€ 3.058", label: "Monatslohn + Überstunden" },
      { value: "38,5 h",  label: "geregelte Woche" },
    ],
    moechtestDuItems: [
      { icon: 'bi-brush',       text: 'dein Handwerk als Lackierer:in in einem international erfolgreichen Unternehmen der Schienenfahrzeugtechnik einsetzen?' },
      { icon: 'bi-train-front', text: 'an beeindruckenden Projekten arbeiten und Züge sowie Waggone mit hochwertigen Mehrschichtlackierungen veredeln?' },
      { icon: 'bi-award',       text: 'langfristig in einem stabilen Betrieb mit echter Übernahmemöglichkeit durch unseren Kunden tätig sein?' },
    ],
    benefits: [
      { icon: 'bi-clock',        title: '38,5-Stunden-Woche',       desc: 'Geregelter 2-Schichtbetrieb zwischen 06:00 und 22:00 Uhr.' },
      { icon: 'bi-cash-stack',   title: '€ 3.058,– Monatslohn',     desc: 'Überstunden werden vollständig ausbezahlt – kein Zeitausgleichskonto.' },
      { icon: 'bi-person-check', title: 'Echte Übernahmechance',    desc: 'Langfristige Perspektive mit Übernahmemöglichkeit durch unseren Kunden.' },
      { icon: 'bi-layers',       title: 'Abwechslungsreiche Arbeit', desc: 'Von Schleifen und Kitten bis zur 7-Schicht-Lackierung – kein Tag wie der andere.' },
      { icon: 'bi-geo-alt-fill', title: '1110 Wien',                desc: 'Öffentlich erreichbar.' },
      { icon: 'bi-building',     title: 'Internationaler Betrieb',  desc: 'Führender Anbieter für Instandhaltung und Weiterentwicklung von Schienenfahrzeugen.' },
    ],
    aufgabenTitle: "Mehr als nur Farbe",
    tasks: [
      'Lackieren von Zügen und Waggonen',
      'Schleifen und Kitten von Zugoberflächen',
      'Arbeiten mit Lackpistolen',
      'Mehrschichtlackierung (7 Schichten)',
    ],
    requirements: [
      'Abgeschlossene Berufsausbildung mit LAP als Lackierer oder Karosseriebautechniker (m/w/d)',
      'Mindestens 2 Jahre Berufserfahrung als Lackierer',
      'Deutschkenntnisse mindestens B2',
      'Selbstständige Arbeitsweise',
      'Teamfähigkeit und Verlässlichkeit',
      'Einwandfreier Leumund',
      'Überstundenbereitschaft auch am Samstag',
      'Bereitschaft für 2-Schichtbetrieb (06:00 – 22:00 Uhr)',
    ],
    jobDetailsImg,
    jobDetailsTagLines: ["Präzision in", "7 Schichten"],
    noteText: "Eine spannende, herausfordernde und abwechslungsreiche Position – jeder Waggon ist ein sichtbares Ergebnis deiner Arbeit.",
    groupImg,
    finalCtaTitle: "Dann bist du bei uns genau richtig!",
    finalCtaText: "Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.",
  },

  quiz: {
    handshakeImg,
  },
};

export default lackierer;
